module.exports = __webpack_public_path__ + "img/games-1.d4ecf6dd.webp";